// extracted by mini-css-extract-plugin
export default {"services":"services_services__Cc-Dl","title":"services_title__6vfq8"};